export default __webpack_public_path__ + "static/media/G0680.34I-26417_-24229_0.1654023360000.87b43f9e.jpg";